<template>
  <el-tabs class="group_4" v-model="activeTab" style="margin-top:10px">
    <el-tab-pane name="login">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">手机验证码登录</div>
      </template>
      <div class="login-content">
        <div class="login-form">
          <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
            <el-form-item prop="phone">
              <el-input v-model="loginForm.phone" placeholder="请输入手机号" class="phone-input">
                <template #prepend>+86</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="email">
              <div class="code-input-group">
                <el-input v-model="loginForm.email" placeholder="请输入验证码" class="code-input">
                </el-input>
                <el-button 
                  @click="sendSmsCodeLogin" 
                  class="get-code-button" 
                  :disabled="!isPhoneValid || loginSmsCountdown > 0 || loginSmsSending">
                  {{ loginSmsCountdown > 0 ? `已发送(${loginSmsCountdown})` : (loginSmsSending ? '发送中...' : '获取验证码') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button @click="loginEmail" class="login-button" type="primary" :loading="loginLoading" :disabled="!isFormValid">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 其他登录方式：除注册页外展示 -->
        <OtherLoginMethods v-if="activeTab !== 'signup'" />
      </div>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" class="register-form">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:100%;height:48px;">
            <template #prepend>+86</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <div class="code-input-group">
            <el-input v-model="registerForm.email" class="code-input" placeholder="请输入验证码">
            </el-input>
            <el-button 
              @click="sendSmsCodeRegister" 
              class="get-code-button" 
              :disabled="!isRegisterPhoneValid || registerSmsCountdown > 0 || registerSmsSending">
              {{ registerSmsCountdown > 0 ? `已发送(${registerSmsCountdown})` : (registerSmsSending ? '发送中...' : '获取验证码') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            :show-password="true" style="width:100%;height:48px;">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button 
            @click="register" 
            class="login-button" 
            type="primary"
            :loading="registerLoading">
            注册并登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import { sendSmsCode, register } from '@/api/user';
import OtherLoginMethods from '../components/OtherLoginMethods.vue'

export default {
  components: {
    OtherLoginMethods
  },
  data() {
    return {
      activeTab: 'login',
      loginSmsCountdown: 0, // 登录验证码倒计时
      registerSmsCountdown: 0, // 注册验证码倒计时
      loginSmsSending: false, // 登录验证码发送中
      registerSmsSending: false, // 注册验证码发送中
      loginForm: {
        phone: '',
        email: '',
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      registerForm: {
        phone: '',
        email: '',
        password: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      },
      loginCountdownTimer: null, // 登录验证码倒计时定时器
      registerCountdownTimer: null, // 注册验证码倒计时定时器
      loginLoading: false, // 登录按钮loading状态
      registerLoading: false // 注册按钮loading状态
    };
  },
  computed: {
    isPhoneValid() {
      return this.loginForm.phone.trim() !== '' && /^1[3-9]\d{9}$/.test(this.loginForm.phone);
    },
    isFormValid() {
      return this.loginForm.phone.trim() !== '' && this.loginForm.email.trim() !== '';
    },
    isRegisterPhoneValid() {
      return this.registerForm.phone.trim() !== '' && /^1[3-9]\d{9}$/.test(this.registerForm.phone);
    }
  },
  beforeDestroy() {
    // 清理定时器，防止内存泄漏
    if (this.loginCountdownTimer) {
      clearInterval(this.loginCountdownTimer);
    }
    if (this.registerCountdownTimer) {
      clearInterval(this.registerCountdownTimer);
    }
  },
  mounted() {
    // 确保页面加载时所有表单都是空的
    this.clearAllForms();
  },
  watch: {
    // 监听标签页切换，切换时清空表单
    activeTab() {
      this.clearAllForms();
    }
  },
  methods: {
    // 清空所有表单数据
    clearAllForms() {
      this.loginForm = {
        phone: '',
        email: '',
      };
      this.registerForm = {
        phone: '',
        email: '',
        password: '',
        agree: false
      };
      // 重置倒计时状态
      this.loginSmsCountdown = 0;
      this.registerSmsCountdown = 0;
      // 清除定时器
      if (this.loginCountdownTimer) {
        clearInterval(this.loginCountdownTimer);
        this.loginCountdownTimer = null;
      }
      if (this.registerCountdownTimer) {
        clearInterval(this.registerCountdownTimer);
        this.registerCountdownTimer = null;
      }
      // 清除表单验证状态
      if (this.$refs.loginFormRef) {
        this.$refs.loginFormRef.clearValidate();
      }
      if (this.$refs.registerFormRef) {
        this.$refs.registerFormRef.clearValidate();
      }
    },
    async sendSmsCodeRegister() {
      // 验证手机号
      if (!this.registerForm.phone) {
        this.$message.error('请输入手机号');
        return;
      }
      if (this.registerSmsSending || this.registerSmsCountdown > 0) return;
      this.registerSmsSending = true;
      try {
        const response = await sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' });
        if (response.data.code == 1) {
          this.$message.success('验证码已发送，请注意查收');
          // 开始倒计时
          this.startRegisterSmsCountdown();
        } else {
          this.$message.error(response.data.msg || '发送失败，请重试');
        }
      } catch (error) {
        this.$message.error('发送失败，请重试');
      } finally {
        this.registerSmsSending = false;
      }
    },
    async sendSmsCodeLogin() {
      // 验证手机号
      if (!this.loginForm.phone) {
        this.$message.error('请输入手机号');
        return;
      }
      if (this.loginSmsSending || this.loginSmsCountdown > 0) return;
      this.loginSmsSending = true;
      try {
        const response = await sendSmsCode({ mobile: this.loginForm.phone, scene: 'YZMDL' });
        if (response.data.code == 1) {
          this.$message.success('验证码已发送，请注意查收');
          // 开始倒计时
          this.startLoginSmsCountdown();
        } else {
          this.$message.error(response.data.msg || '发送失败，请重试');
        }
      } catch (error) {
        this.$message.error('发送失败，请重试');
      } finally {
        this.loginSmsSending = false;
      }
    },
    startLoginSmsCountdown() {
      // 清除之前的定时器
      if (this.loginCountdownTimer) {
        clearInterval(this.loginCountdownTimer);
      }
      
      this.loginSmsCountdown = 60;
      this.loginCountdownTimer = setInterval(() => {
        this.loginSmsCountdown--;
        if (this.loginSmsCountdown <= 0) {
          clearInterval(this.loginCountdownTimer);
          this.loginCountdownTimer = null;
        }
      }, 1000);
    },
    startRegisterSmsCountdown() {
      // 清除之前的定时器
      if (this.registerCountdownTimer) {
        clearInterval(this.registerCountdownTimer);
      }
      
      this.registerSmsCountdown = 60;
      this.registerCountdownTimer = setInterval(() => {
        this.registerSmsCountdown--;
        if (this.registerSmsCountdown <= 0) {
          clearInterval(this.registerCountdownTimer);
          this.registerCountdownTimer = null;
        }
      }, 1000);
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        
        this.registerLoading = true;
        
        register({ 
          account: this.registerForm.phone, 
          password: this.registerForm.password, 
          sms_code: this.registerForm.email, 
          terminal: 4
        }).then(response => {
          if (response.data.code == 1) {
            this.$message.success('注册成功');
            setTimeout(() => {
              this.activeTab = "login";
              // 清空注册表单
              this.$refs.registerFormRef.resetFields();
            }, 1500);
          }
        }).catch(error => {
          // 错误会被axios拦截器统一处理并显示，这里不需要额外处理
        }).finally(() => {
          this.registerLoading = false;
        });
      })
    },
    async loginEmail() {
      this.$refs["loginFormRef"].validate(async (valid) => {
        if (!valid) return
        
        this.loginLoading = true;
        
        try {
          const data = await this.$store.dispatch('user/loginEmail', { 
            mobile: this.loginForm.phone, 
            code: this.loginForm.email,
          });
          
          // 登录成功，获取用户信息
          const userInfo = await this.$store.dispatch('user/getInfo');
          localStorage.setItem('userInfo', JSON.stringify(userInfo.data));
          this.$message.success('登录成功');
          this.$router.push('/store/dashboard');
        } catch (error) {
          // 错误已被axios拦截器统一处理并显示，这里不需要额外处理
        } finally {
          this.loginLoading = false;
        }
      })
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 全局溢出控制 */
.group_4 {
  overflow: visible;
  max-width: 100%;
  box-sizing: border-box;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  min-height: 405px;
  height: auto;
  border: none;
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: transparent;
  overflow: visible;
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__active-bar {
  border-radius: 500px;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
  position: relative;
}

::v-deep .el-tabs__nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(101, 101, 135, 0.40);
}

::v-deep .el-tabs__item:nth-child(1) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  position: relative;
}

::v-deep .el-tabs__item:nth-child(1)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: 0px !important;
  position: relative;
}

::v-deep .el-tabs__item:nth-child(2)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: 0px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 8px 0px 0px 8px;
  border: 1px solid rgba(101, 101, 135, 0.20);
  background: linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.70) 99.08%);
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 48px;
  font-size: large;
}

::v-deep .phone-input .el-input__inner {
  border-radius: 0 8px 8px 0;
}

.code-input-group {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.code-input {
  flex: 1;
}

::v-deep .code-input .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* 登录内容容器 */
.login-content {
  padding: 20px 35px;
  background: transparent;
  position: relative;
  z-index: 5;
  overflow: visible;
  max-width: 100%;
  box-sizing: border-box;
}

/* 登录表单样式 */
.login-form {
  margin-bottom: 25px;
  overflow: visible;
  max-width: 100%;
  box-sizing: border-box;
}

/* 统一注册表单项间距 */
.register-form :deep(.el-form-item) {
  margin-bottom: 16px;
}

.phone-input,
.code-input {
  width: 100%;
  margin-bottom: 16px;
}

::v-deep .phone-input .el-input__inner,
::v-deep .code-input .el-input__inner {
  height: 48px;
  border-radius: 0 8px 8px 0;
  border: 1px solid #e0e0e0;
  font-size: 16px;
  padding: 0 15px;
  position: relative;
  z-index: 2;
  border-left: 0px;
}

::v-deep .phone-input .el-input__inner:focus,
::v-deep .code-input .el-input__inner:focus {
  border-color: #B16EF9;
  box-shadow: 0 0 0 2px rgba(177, 110, 249, 0.2);
}

.get-code-button {
  width: 120px;
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
  font-family: "Source Han Sans CN VF";
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent; /* 确保文本颜色由渐变渲染 */
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(0px);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Element UI 会在按钮里包一层 span，这里同步应用文字渐变避免 hover 时被覆盖 */
.get-code-button span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent !important;
}

.get-code-button:not(:disabled) span,
.get-code-button:not(:disabled) {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.get-code-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(156, 65, 255, 0.3);
  background-color: transparent !important; /* 防止库样式覆盖 */
  color: transparent !important;
}

.get-code-button:disabled {
  cursor: not-allowed;
}


.login-button {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  background: #BEBEBE;
  border: none;
  cursor: not-allowed;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.login-button:not(:disabled) {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  cursor: pointer;
}

.login-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(156, 65, 255, 0.3);
}

::v-deep .el-form-item {
  margin-bottom: 16px;
}

::v-deep .el-form-item__error {
  left: 0;
  font-size: 14px;
  color: #f56c6c;
  position: relative;
  z-index: 1;
}

/* 禁用态：保持清晰边界与灰色文字，悬停不变色 */
/* 提升选择器优先级，去掉 !important */
.group_4 .code-input-group .get-code-button.is-disabled,
.group_4 .code-input-group .get-code-button:disabled,
.group_4 .code-input-group .get-code-button.is-disabled:hover,
.group_4 .code-input-group .get-code-button:disabled:hover,
.group_4 .code-input-group .get-code-button.is-disabled:focus,
.group_4 .code-input-group .get-code-button:disabled:focus {
  background: none;
  background-color: #fff; /* 白底，避免透明导致看不清 */
  border: 1px solid #d9d9d9; /* 明显的边框 */
  -webkit-text-fill-color: #bfbfbf;
  color: #bfbfbf; /* 灰色文字 */
  box-shadow: none;
}

/* Element 按钮内部的 span 在禁用时使用灰色文本，移除渐变 */
.group_4 .code-input-group .get-code-button.is-disabled > span,
.group_4 .code-input-group .get-code-button:disabled > span,
.group_4 .code-input-group .get-code-button.is-disabled:hover > span,
.group_4 .code-input-group .get-code-button:disabled:hover > span,
.group_4 .code-input-group .get-code-button.is-disabled:focus > span,
.group_4 .code-input-group .get-code-button:disabled:focus > span {
  background: none;
  -webkit-background-clip: initial;
  background-clip: initial;
  -webkit-text-fill-color: #bfbfbf;
  color: #bfbfbf;
}

</style>